var React = require('react');

function Filter (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M20.9431 6.27851H1.71208C1.15227 6.27851 0.741333 5.94182 0.741333 5.39302C0.741333 4.84422 1.1948 4.39999 1.75461 4.39999H20.8952C21.4551 4.39999 21.9085 4.84422 21.9085 5.39302C21.9085 5.94182 21.5029 6.27851 20.9431 6.27851ZM4.36241 10.0656H18.6771C19.0938 10.0656 19.3929 10.4556 19.3929 11.0044C19.3929 11.5532 19.0938 11.9426 18.6771 11.9426H4.36241C3.94572 11.9426 3.64663 11.5532 3.64663 11.0044C3.64663 10.4556 3.94572 10.0656 4.36241 10.0656ZM8.07516 15.7311H14.7637C15.0419 15.7311 15.2434 16.0582 15.2434 16.607C15.2434 17.1558 15.0181 17.6 14.7399 17.6H8.02382C7.74567 17.6 7.52036 17.1558 7.52036 16.607C7.52036 16.0582 7.79701 15.7311 8.07516 15.7311Z","fill":"white"}));
}

Filter.defaultProps = {"viewBox":"0 0 22 22","fill":"none"};

module.exports = Filter;

Filter.default = Filter;
